import config from 'services/table/const';
import Action from './table.action';

let table = { ...config };
table.url = '/tms/service/type';
table.columns = {
  name: {
    title: 'Nama',
    sortable: true,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.name}
          </div>
          <small className="info text-uppercase">
            {row?.service.name}
          </small>
        </div>
      );
    },
  },
  dividers: {
    title: 'Pembagi m3',
    sortable: false,
    format_number: true,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
  },
  action: {
    sortable: false,
    title: '',
    width: 30,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
